import { KeyValue } from '@angular/common';
import { PermIdIndexerEnum } from './permid-indexer-enum';
import { NavigationUtils } from '../navigation-utils';
import { environment } from 'src/environments/environment';

export class Breadcrumb {
    private label: string;
    private item: KeyValue<string, string>;
    private children: Array<KeyValue<string, string>>;
    private regularShortcuts: Array<KeyValue<string, string>>;
    private indicatorShortcuts: Array<KeyValue<string, string>>;
    private displayIndicatorShortcuts = false;

    constructor(item: KeyValue<string, string>) {
        this.item = item;
        this.label = Breadcrumb.getLabel(item);
    }

    get Label(): string {
        return this.label;
    }
    set Label(value: string) { this.label = value; }

    get Item(): KeyValue<string, string> { return this.item; }
    set Item(value: KeyValue<string, string>) { this.item = value; }

    get Children(): Array<KeyValue<string, string>> { return this.children; }
    set Children(value: Array<KeyValue<string, string>>) { this.children = value; }

    get DisplayIndicatorShortcuts(): boolean { return this.displayIndicatorShortcuts; }
    set DisplayIndicatorShortcuts(value: boolean) { this.displayIndicatorShortcuts = value; }

    get ShortcutItems(): Array<KeyValue<string, string>> {
        return (this.displayIndicatorShortcuts) ? this.IndicatorShortcutItems : this.RegularShortcutItems;
    }
    set ShortcutItems(value: Array<KeyValue<string, string>>) {
        if (this.displayIndicatorShortcuts) {
            this.indicatorShortcuts = value;
        } else {
            this.regularShortcuts = value;
        }
    }

    get RegularShortcutItems(): Array<KeyValue<string, string>> { return this.regularShortcuts; }
    set RegularShortcutItems(value: Array<KeyValue<string, string>>) { this.regularShortcuts = value; }

    get IndicatorShortcutItems(): Array<KeyValue<string, string>> { return this.indicatorShortcuts; }
    set IndicatorShortcutItems(value: Array<KeyValue<string, string>>) { this.indicatorShortcuts = value; }

    public static isHomeCrumb(permItemID) {
        const isHome = (permItemID === environment.HomePermId);
        return isHome;
    }

    public static isIndicatorCrumb(permItemID) {
        const isIndicator = NavigationUtils.IsLastPartIndicatorItemFromPermId(permItemID);
        return isIndicator;
    }

    

    public static isHospitalIndicatorCrumb(permItemID) {
        const isHospIndicator = NavigationUtils.IsLastPartHospitalIndicatorItemFromPermId(permItemID);
        return isHospIndicator;
    }

    public static isUnitDashboardCrumb(permItemID) {
        const isUnit = NavigationUtils.IsLastPartUnitItemFromPermId(permItemID);
        return isUnit;
    }

    public static getLabel(kv: KeyValue<string, string>) {
        let label = kv.value;
        if (Breadcrumb.isUnitDashboardCrumb(kv.key)) {
            const parts = kv.key.split('_');

            const hospIndex = PermIdIndexerEnum.Hospital as number;
            const hcode = (parts && parts.length > hospIndex) ? parts[hospIndex] : '';

            const unitIndex = PermIdIndexerEnum.Unit as number;
            const unit = parts[unitIndex].replace('u', '');
            label = `${kv.value} (${unit})`;
        }
        return label;
    }
}
